/*
 * @Author: 肖玲
 * @Date: 2023-03-01 13:56:21
 * @LastEditTime: 2023-03-02 17:56:08
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: /p2ps_vip_web/src/router/butterfly-flow-system/flow-direction-statistic-analy/modules/priceAnalyRouter.js
 * 价格分析
 */
const priceAnalyRouter = [
  // 价格分析
  {
    path: '/flowSystem/priceAnalysis',
    name: 'flowSystemStatisticsPriceAnalysis',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '../views/flowSystem/statistics/PriceAnalysis.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/price-analy/analy/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '价格分析', //二级菜单
      title: '价格分析',
    },
  },
  // 价格分析 明细
  {
    path: '/flowSystem/PriceAnalysisDetail/:routeParam',
    name: 'flowSystemStatisticsPriceAnalysisDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '../views/flowSystem/statistics/PriceAnalysisDetail.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/price-analy/analy/Detail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '价格分析', //二级菜单
      title: '价格分析明细',
      breadcrumb: [
        {
          title: '价格分析',
          name: 'flowSystemStatisticsPriceAnalysis',
        },
      ],
    },
  },
  // 价格预警
  {
    path: '/flowSystem/pricediff',
    name: 'flowSystemStatisticsPriceDiff',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '../views/flowSystem/statistics/PriceDiff.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/price-analy/early-warning/Page.vue'
      ),  //新迁移文件
    meta: {
      SecondaryMenu: '价格分析', //二级菜单
      title: '价格预警',
    },
  },
]
export default priceAnalyRouter
